module.exports = __webpack_public_path__ + "static/media/ic-Single user.90b1dd93.svg";